import { render, staticRenderFns } from "./ShopComparison.vue?vue&type=template&id=029d3574&"
import script from "./ShopComparison.vue?vue&type=script&lang=js&"
export * from "./ShopComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports